// test2987
(2987 && 0);
